import { Store } from 'vuex';
import { useToast } from 'vue-toastification';
import i18n from '../locales/i18n';
import { populateEnvs } from '../environment';
import representasjoner from './modules/representasjoner';

function matchesOrgNumber(orgnr) {
  return /^\d{9}$/.exec(orgnr) !== null;
}

const toast = useToast();
const commonToastOptions = {
  position: 'bottom-right',
  timeout: 10000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: false,
  icon: true,
  rtl: false,
};

const state = {
  accessToken: null,
  brukerinfo: {},
  environments: populateEnvs(),
  isAuthenticated: false,
  backlink: {
    href: '',
    text: '',
  },
  loginLevel4Function: () => {},
  updateToken: () => Promise.resolve(true),
};

export const getters = {
  getBacklink: (state) => state.backlink,
};

export const actions = {
  setAccessToken({ commit }, accessToken) {
    commit('SET_ACCESSTOKEN', accessToken);
  },
  setAuthenticated({ commit }, isAuthenticated) {
    commit('SET_AUTHENTICATED', isAuthenticated);
  },
  setBacklink({ commit }, backlink) {
    commit('SET_BACKLINK', backlink);
  },
  setBrukerinfo({ commit }, brukerinfo) {
    commit('SET_BRUKERINFO', brukerinfo);
  },
  setKeycloakUpdateToken({ commit }, updateToken) {
    commit('SET_KEYCLOAK_UPDATE_TOKEN', updateToken);
  },
  setLoginLevel4Function({ commit }, loginFunc) {
    commit('SET_LOGINLEVEL4_FUNCTION', loginFunc);
  },
  addGlobalMessage(context, { messageType, message }) {
    if (!message) throw new Error('Message is required');

    if (messageType === 'info') {
      toast.info(message, {
        ...commonToastOptions,
      });
    } else if (messageType === 'error') {
      toast.error(message, {
        ...commonToastOptions,
      });
    }
  },
  addDefaultErrorToGlobalMessage({ dispatch }, error) {
    let message = '';
    if (error && error.status) {
      switch (error.status) {
        case 401:
          message = i18n.global.t('shared.error.notLoggedIn').toString();
          break;
        case 403:
          if (matchesOrgNumber(state.representasjoner.currentRepresentation.identifikator)) {
            message = i18n.global.t('shared.error.forbiddenOrganization').toString();
          } else {
            message = i18n.global.t('shared.error.forbiddenPrivate').toString();
          }
          break;
        case 404:
          message = i18n.global.t('shared.error.notFound').toString();
          break;
        case 500:
          message = i18n.global.t('shared.error.internalServerError').toString();
          break;
        case 503:
          message = i18n.global.t('shared.error.internalServerError').toString();
          break;
        default:
          message = i18n.global.t('shared.error.unknown').toString();
          break;
      }
    } else {
      message = i18n.global.t('shared.error.internalServerError').toString();
    }
    dispatch('addGlobalMessage', { messageType: 'error', message, error });
  },
};

export const mutations = {
  SET_ACCESSTOKEN(state, accessToken) {
    state.accessToken = accessToken;
  },
  SET_BACKLINK(state, obj) {
    state.backlink = obj;
  },
  SET_LOGINLEVEL4_FUNCTION(state, loginFunc) {
    state.loginLevel4Function = loginFunc;
  },
  SET_BRUKERINFO(state, brukerinfo) {
    state.brukerinfo = brukerinfo;
  },
  SET_AUTHENTICATED(state, isAuthenticated) {
    state.isAuthenticated = isAuthenticated;
  },
  SET_KEYCLOAK_UPDATE_TOKEN(state, updateToken) {
    state.updateToken = updateToken;
  },
};

export const storeStructure = {
  strict: state.environments.NODE_ENV !== 'prod',
  state,
  getters,
  actions,
  mutations,
  modules: {
    representasjoner,
  },
};

export default new Store(storeStructure);
